import moment from "moment";

const isValidDateTime = val => {
  return !moment(val).isBefore(
    moment()
      .add(2, "hours")
      .subtract(1, "minutes")
      .format()
  );
};

const isInvalidTimeFormat = val => {
  if (val) {
    let testA = /\d{1,2}:\d{2}/.test(val);
    let testB = /\d{4}/.test(val);
    return !(testA || testB) ? false : true;
  } else {
    return true;
  }
};

export { isValidDateTime, isInvalidTimeFormat };
